// extracted by mini-css-extract-plugin
export default {"input":"AddBatchForm_input__yBvlf"};